<template>
  <div>

    <!--v-show="show"-->
    <div align="right">
      <el-form :inline="true" class="style1">
        <el-form-item>
          <el-button class="el-icon-circle-plus-outline" type="text" @click="dialogVisible = true">
            {{$t("general.add")}}
          </el-button>
        </el-form-item>
      </el-form>
    </div>
    <el-table :data="tableData" highlight-current-row border style="width: 100%; margin-top: 0px" :empty-text="$t('general.empty_data')">

      <el-table-column :label="$t('general.date')" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.date }}</span>
        </template>
      </el-table-column>

      <el-table-column　:label="$t('companyInfo.name')" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.comName }}</span>
        </template>
      </el-table-column>

      <el-table-column　label="被保険者氏名" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.empName }}</span>
        </template>
      </el-table-column>

      <el-table-column　label="照会者氏名" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.inquirer }}</span>
        </template>
      </el-table-column>

      <el-table-column :label="$t('general.operation')" align="center" width="360">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" icon="el-icon-edit" @click="handleEdit(scope.$index, scope.row)">
            {{$t("general.edit")}}
          </el-button>
          <el-button size="mini" type="danger" icon="el-icon-delete" @click="handleDelete(scope.$index, scope.row)">
            {{$t("general.delete")}}
          </el-button>
          <el-button size="mini" type="success" icon="el-icon-view" @click="printPDF(scope.$index, scope.row)">
            {{$t("general.print")}}
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="pages">
      <el-pagination background :disabled="disablePage" :current-page.sync="currentPage" small layout="prev, pager, next" :page-size="pageSize" :total="total" @current-change="handleCurrentChange">
      </el-pagination>
    </div>

    <!-- adding new -->

    <el-dialog :title="$t('general.add')" :append-to-body="true" :visible.sync="dialogVisible" width="30%" :before-close="handleClose">
      <el-form :model="inputForm" :rules="rules" ref="inputForm" label-width="9rem" class="demo-inputForm" size="medium" :label-position="labelPosition" style="width: 90%; margin-left: 5%; margin-right: 5%;">
        <el-input type="hidden" v-model="inputForm.id" />

        <el-form-item :label="$t('general.date')+':'" prop="date">
          <el-date-picker v-model="inputForm.date" size="mini" value-format="yyyy-MM-dd" type="date" style="width: 100%;">
          </el-date-picker>
        </el-form-item>
        <el-form-item :label="$t('companyInfo.name')+':'" prop="company_id">
          <el-select v-model="inputForm.company_id" clearable size="mini" :empty-text="$t('general.empty_data')" :placeholder="$t('general.please_select')" style="width: 100%;">
            <el-option v-for="item in companyInfo" :key="item.id" :label="item.name1" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item :label="$t('general.employee_id') + ':'" prop="employee_id">
          <el-select v-model="inputForm.employee_id" clearable size="mini" :empty-text="$t('general.empty_data')" :placeholder="$t('general.please_select')" style="width: 100%;">
            <el-option v-for="item in empList" :key="item.id" :label="item.employee_id" :value="item.employee_id">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="被保険者氏名:" prop="employee_id">
          <el-select v-model="inputForm.employee_id" clearable size="mini" :empty-text="$t('general.empty_data')" :placeholder="$t('general.please_select')" style="width: 100%;">
            <el-option v-for="item in empList" :key="item.id" :label="item.name" :value="item.employee_id">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="照会者氏名:" prop="inquirer">
          <el-input v-model="inputForm.inquirer" size=mini prefix-icon="el-icon-edit"></el-input>
        </el-form-item>

        <el-form-item label="照会者電話番号:" prop="phone">
          <el-input v-model="inputForm.phone" size=mini prefix-icon="el-icon-edit"></el-input>
        </el-form-item>

        <el-form-item label="備考:">
          <el-input v-model="inputForm.remark" prefix-icon="el-icon-edit" size="mini"></el-input>
        </el-form-item>

      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button style="width:120px" @click="add('inputForm')" type="primary" size="medium">
          {{$t("general.confirm")}}
        </el-button>
        <el-button style="width:120px" @click="cancel()" size="medium">
          {{$t("general.cancel")}}
        </el-button>
      </span>
    </el-dialog>

    <!-- edit -->

    <el-dialog :title="$t('general.edit')" :append-to-body="true" :visible.sync="dialogEdit" width="30%" :before-close="handleClose">
      <el-form :model="inputForm" :rules="rules" ref="inputForm" label-width="9rem" class="demo-inputForm" size="medium" :label-position="labelPosition" style="width: 90%; margin-left: 5%; margin-right: 5%;">
        <el-input type="hidden" v-model="inputForm.id" />

        <el-form-item :label="$t('general.date')+':'" prop="date">
          <el-date-picker v-model="inputForm.date" size="mini" value-format="yyyy-MM-dd" type="date" style="width: 100%;">
          </el-date-picker>
        </el-form-item>
        <el-form-item :label="$t('companyInfo.name')+':'" prop="company_id">
          <el-select v-model="inputForm.company_id" size="mini" :empty-text="$t('general.empty_data')" :placeholder="$t('general.please_select')" style="width: 100%;">
            <el-option v-for="item in companyInfo" :key="item.id" :label="item.name1" :value="item.id" disabled>
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item :label="$t('general.employee_id') + ':'" prop="employee_id">
          <el-select v-model="inputForm.employee_id" clearable size="mini" :empty-text="$t('general.empty_data')" :placeholder="$t('general.please_select')" style="width: 100%;">
            <el-option v-for="item in empList" :key="item.id" :label="item.employee_id" :value="item.employee_id">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="被保険者氏名:" prop="employee_id">
          <el-select v-model="inputForm.employee_id" clearable size="mini" :empty-text="$t('general.empty_data')" :placeholder="$t('general.please_select')" style="width: 100%;">
            <el-option v-for="item in empList" :key="item.id" :label="item.name" :value="item.employee_id">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="照会者氏名:" prop="inquirer">
          <el-input v-model="inputForm.inquirer" size=mini prefix-icon="el-icon-edit"></el-input>
        </el-form-item>

        <el-form-item label="照会者電話番号:" prop="phone">
          <el-input v-model="inputForm.phone" size=mini prefix-icon="el-icon-edit"></el-input>
        </el-form-item>

        <el-form-item label="備考:">
          <el-input v-model="inputForm.remark" prefix-icon="el-icon-edit" size="mini"></el-input>
        </el-form-item>

      </el-form> <span slot="footer" class="dialog-footer">
        <el-button style="width:120px" @click="edit('inputForm')" type="primary" size="medium">
          {{$t("general.confirm")}}
        </el-button>
        <el-button style="width:120px" @click="cancel()" size="medium">
          {{$t("general.cancel")}}
        </el-button>
      </span>
    </el-dialog>

    <div style="text-align: left; margin-top: 50vh; font-size: smaller; width: fit-content; ">
      <el-card style="background-color: #51d1ff1c;">
        注意
        <ol>
          <li>
            この照会票は、現在働いている（以前働いていた）事業所（以下「照会対象事業所」という。）において雇用保
            　険の被保険者資格の取得手続きが行われているかどうかについて、公共職業安定所に対して照会、確認する際に用
            　いるものです。
          </li>
          <li>
            照会を希望する場合は、照会票に必要事項を記載し、本人確認及び本人の住居所の確認できる官公署の発行した
            　確認書類（「運転免許証」「個人番号カード」「国民健康保険被保険者証」「雇用保険受給資格者証」「出稼労働
            　者手帳」「住民票の写し」「印鑑証明書」等のいずれか（コピー可））を添付して、本人が、原則として照会対象
            　事業所の所在地又は本人の住居所を管轄する公共職業安定所に提出してください。　
          </li>
          <li>
            照会票の提出は代理人又は郵送によっても行うことができます。ただし、代理人による提出の場合「委任状」が
            　必要となります。委任状の文例＝「私は、（代理人住所）に住む（代理人氏名）を代理人に定めて、（照会先安定
            　所）に雇用保険被保険者資格取得届出確認照会票及び確認書類を提出することを委任します。（本人住居所・氏
            　名・印）（委任の年月日）」
            　　また、郵送による提出の場合、事故防止のため、上記２の書類については、いずれかの書類のコピー、又は原本
            　の場合は「住民票の写し」若しくは「印鑑証明書」に限ります。
          </li>
        </ol>
      </el-card>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      pageSize: 6,
      currentPage: 1,
      total: 0,
      disablePage: false,

      labelPosition: "left",

      dialogVisible: false,
      dialogEdit: false,

      tableData: [],
      companyInfo: [],
      empList: [{
        id: "",
        employee_id: "",
        name: "",
      }],

      inputForm: {
        date: "",
        company_id: "",
        employee_id: "",
        inquirer: "",
        phone: "",
        remark: "",
      },

      rules: {
        company_id: [{
          required: true,
          message: this.$t("general.please_select"),
          trigger: "blur",
        },],
        date: [{
          required: true,
          message: this.$t("general.please_select"),
          trigger: "blur",
        },],
        employee_id: [{
          required: true,
          message: this.$t("general.please_select"),
          trigger: "blur",
        },],
        inquirer: [{
          required: true,
          message: this.$t("general.inputinfo"),
          trigger: "blur",
        },],
        phone: [{
          required: true,
          message: this.$t("general.inputinfo"),
          trigger: "blur",
        },],
      },
    }
  },

  methods: {
    preview(row) {
      // var uid = window.localStorage.getItem('LoginUserId');
      window.open(
        "/pdf/雇用保険被保険者資格取得届出確認照会票-" + row.empName + "-" + row.date + ".pdf"

      );
    },

    printPDF(index, row) {
      let postData = this.qs.stringify({
        id: row.id
      });
      this.axios({
        method: "post",
        url: "/printEmpInsInquiry",
        data: postData
      })
        .then(response => {
          this.$message({
            type: "success",
            message: this.$t("general.print_completed")
          });
          setTimeout(() => {
            this.preview(row);
          }, 300);
        })
        .catch(error => {
          this.$message({
            type: "warning",
            message: this.$t("general.print_failed")
          });
          console.log(error);
        });
    },


    add(form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          let postData = this.qs.stringify({
            company_id: this.inputForm.company_id,
            employee_id: this.inputForm.employee_id,
            inquirer: this.inputForm.inquirer,
            phone: this.inputForm.phone,
            date: this.inputForm.date,
            remark: this.inputForm.remark
          });
          this.axios({
            method: "post",
            url: "/insertEmpInsInquiry",
            data: postData
          })
            .then(response => {
              this.$message({
                type: "success",
                message: this.$t("general.add_completed")
              });
              this.currentPage = 1;
              this.getPages();
              this.dialogVisible = false;
              this.emptyForm();
            })
            .catch(error => {
              this.$message({
                type: "warning",
                message: this.$t("general.add_failed")
              });
              console.log(error);
            });
        } else {
          // console.log("error submit!!");
          this.$message({
            type: "error",
            message: this.$t("general.valid_failed")
          });
          return false;
        }
      });
    },

    handleEdit(index, row) {
      this.dialogEdit = true;
      this.inputForm = Object.assign({}, row);
    },

    edit(form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          let postData = this.qs.stringify({
            id: this.inputForm.id,
            employee_id: this.inputForm.employee_id,
            inquirer: this.inputForm.inquirer,
            phone: this.inputForm.phone,
            date: this.inputForm.date,
            remark: this.inputForm.remark
          });
          this.axios({
            method: "post",
            url: "/updateEmpInsInquiry",
            data: postData
          })
            .then(response => {
              this.handleCurrentChange();
              this.dialogEdit = false;
              this.emptyForm();
              this.$message({
                type: "success",
                message: this.$t("general.edit_completed")
              });
              // console.log(response);
            })
            .catch(error => {
              this.$message({
                type: "warning",
                message: this.$t("general.edit_failed")
              });
              console.log(error);
            });
        } else {
          console.log("error submit!!");
          this.$message({
            type: "error",
            message: this.$t("general.valid_failed")
          });
          return false;
        }
      });
    },

    handleDelete(index, row) {
      this.$confirm(this.$t("general.sure_delete"), this.$t("general.hint"), {
        cancelButtonClass: "btn-custom-cancel",
        confirmButtonClass: "btn-custom-confirm",
        confirmButtonText: "OK",
        cancelButtonText: this.$t("general.cancel"),
        type: "warning"
      })
        .then(() => {
          let postData = this.qs.stringify({
            id: row.id
          });
          this.axios({
            method: "post",
            url: "/deleteEmpInsInquiry",
            data: postData
          })
            .then(response => {
              this.getPages();
              this.$message({
                type: "success",
                message: this.$t("general.delete_completed")
              });
            })
            .catch(error => {
              console.log(error);
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: this.$t("general.canceled")
          });
        });
    },


    cancel() {
      this.dialogVisible = false;
      this.dialogEdit = false;
      this.emptyForm();
      this.$refs['inputForm'].resetFields();
    },

    emptyForm() {
      this.inputForm = {
        date: "",
        company_id: "",
        employee_id: "",
        inquirer: "",
        phone: "",
        remark: "",
      }
    },

    handleClose(done) {
      this.$confirm(this.$t("general.close_comfirm"), {
        cancelButtonClass: "btn-custom-cancel",
        confirmButtonClass: "btn-custom-confirm",
        confirmButtonText: this.$t("general.confirm"),
        cancelButtonText: this.$t("general.cancel"),
        type: "warning"
      })
        .then(_ => {
          done();
          this.emptyForm();
        })
        .catch(_ => { });
    },

    handleCurrentChange() {
      let postData = this.qs.stringify({
        page: this.currentPage
      });
      this.axios({
        method: "post",
        url: "/pageEmpInsInquiry",
        data: postData
      })
        .then(response => {
          this.tableData = response.data;
        })
        .catch(error => {
          console.log(error);
        });
    },

    getPages() {
      this.axios
        .post("/pageEmpInsInquiry")
        .then(response => {
          this.show = true
          this.tableData = response.data;
        })
        .catch(error => {
          this.show = false;
          this.$message({
            type: 'error',
            message: '開発中です。'
          });
          console.log(error);
        });
      this.axios
        .post("/rowsEmpInsInquiry")
        .then(response => {
          this.total = response.data;
        })
        .catch(error => {
          console.log(error);
        });
    },

  },

  created() {
    this.getPages();

    //get Company List
    this.axios
      .post("/ListComInfo")
      .then((response) => {
        this.companyInfo = response.data;
        console.log(this.companyInfo);
      })
      .catch((error) => {
        console.log(error);
      });

    //get Employee Name
    this.axios
      .post("/ListEmpListForInsNameChange")
      .then(response => {
        this.empList = response.data;
      })
      .catch(error => {
        console.log(error);
      });
  }


}
</script>

<style scoped>
.style1 {
  margin-right: 100px;
  padding: 0px;
  text-align: right;
}

.pages {
  margin: 0px;
  padding: 0px;
  text-align: right;
}
</style>


// WEBPACK FOOTER //
// src/components/EmpIns/EmpInsInquiry.vue